import {
  BoxGeometry,
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry
} from 'three';

/** Compact Sivir mesh — gold armor + crossblade. */
export function createSivirMesh(team = 'blue') {
  const group = new Group();
  const armor = team === 'blue' ? 0xca8a04 : 0x854d0e;
  const armorMat = new MeshStandardMaterial({
    color: armor, metalness: 0.55, roughness: 0.35
  });
  const bladeMat = new MeshStandardMaterial({
    color: 0xfef08a, metalness: 0.8, roughness: 0.25
  });
  const skinMat = new MeshStandardMaterial({ color: 0xd6a07a, roughness: 0.7 });

  const torso = new Mesh(new CylinderGeometry(0.45, 0.55, 1.8, 10), armorMat);
  torso.position.y = 1.3;
  group.add(torso);

  const head = new Mesh(new SphereGeometry(0.4, 12, 12), skinMat);
  head.position.y = 2.55;
  group.add(head);

  const blade = new Mesh(new BoxGeometry(1.8, 0.12, 0.35), bladeMat);
  blade.position.set(0.7, 1.6, 0.4);
  blade.rotation.z = 0.3;
  group.add(blade);

  const cross = new Mesh(new BoxGeometry(0.12, 1.4, 0.3), bladeMat);
  cross.position.copy(blade.position);
  cross.rotation.z = 0.3;
  group.add(cross);

  return group;
}
